import { FC } from 'react';

import { useCopyToClipboard } from '@/hooks';
import { SvgIcon } from '@/components/SvgIcon';

import styles from './ReferralLink.module.sass';

interface ReferralLinkProps {
  value: string;
}

const ReferralLink: FC<ReferralLinkProps> = ({ value }) => {
  const [, copy] = useCopyToClipboard();

  return (
    <button type="button" className={styles.link} onClick={() => copy(value)}>
      <SvgIcon name="copy" className={styles.icon} />
      <span>{value}</span>
    </button>
  );
};

export default ReferralLink;
